// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "./Json.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_JSON from "@rescript/runtime/lib/es6/Stdlib_JSON.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function mapError(result, fn) {
  if (result.TAG === "Ok") {
    return result;
  } else {
    return {
      TAG: "Error",
      _0: fn(result._0)
    };
  }
}

function prependLocation(err, loc) {
  let variant = err.NAME;
  if (variant === "MissingField") {
    let match = err.VAL;
    let location$p = Belt_Array.concatMany([
      [loc],
      match[0]
    ]);
    return {
      NAME: "MissingField",
      VAL: [
        location$p,
        match[1]
      ]
    };
  }
  if (variant === "SyntaxError") {
    return err;
  }
  if (variant === "UnexpectedJsonType") {
    let match$1 = err.VAL;
    let location$p$1 = Belt_Array.concatMany([
      [loc],
      match$1[0]
    ]);
    return {
      NAME: "UnexpectedJsonType",
      VAL: [
        location$p$1,
        match$1[1],
        match$1[2]
      ]
    };
  }
  let match$2 = err.VAL;
  let location$p$2 = Belt_Array.concatMany([
    [loc],
    match$2[0]
  ]);
  return {
    NAME: "UnexpectedJsonValue",
    VAL: [
      location$p$2,
      match$2[1]
    ]
  };
}

function encodeWith(data, codec) {
  return codec.encode(data);
}

function decodeWith(json, codec) {
  return codec.decode(json);
}

function string_decode(json) {
  let x = Json.decodeString(json);
  if (x !== undefined) {
    return {
      TAG: "Ok",
      _0: x
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "UnexpectedJsonType",
        VAL: [
          [],
          "string",
          json
        ]
      }
    };
  }
}

let string = {
  encode: Json.encodeString,
  decode: string_decode
};

function float_decode(json) {
  let x = Json.decodeNumber(json);
  if (x !== undefined) {
    return {
      TAG: "Ok",
      _0: x
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "UnexpectedJsonType",
        VAL: [
          [],
          "number",
          json
        ]
      }
    };
  }
}

let float = {
  encode: Json.encodeNumber,
  decode: float_decode
};

function int_encode(x) {
  return Json.encodeNumber(x);
}

function int_decode(json) {
  return Stdlib_Result.flatMap(float_decode(json), x => {
    if (x === Math.trunc(x) && x >= -2147483648 && x <= 2147483647) {
      return {
        TAG: "Ok",
        _0: Math.trunc(x) | 0
      };
    } else {
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            x.toString()
          ]
        }
      };
    }
  });
}

let int = {
  encode: int_encode,
  decode: int_decode
};

function bool_decode(json) {
  let x = Json.decodeBoolean(json);
  if (x !== undefined) {
    return {
      TAG: "Ok",
      _0: x
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "UnexpectedJsonType",
        VAL: [
          [],
          "bool",
          json
        ]
      }
    };
  }
}

let bool = {
  encode: Json.encodeBoolean,
  decode: bool_decode
};

function nullable(payloadCodec) {
  return {
    encode: maybeValue => {
      if (maybeValue !== undefined) {
        return payloadCodec.encode(Primitive_option.valFromOption(maybeValue));
      } else {
        return null;
      }
    },
    decode: json => {
      if (json === null) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return Stdlib_Result.map(payloadCodec.decode(json), v => Primitive_option.some(v));
      }
    }
  };
}

function array(elementCodec) {
  return {
    encode: x => Json.encodeArray(x.map(v => elementCodec.encode(v))),
    decode: json => {
      let elementJsons = Stdlib_JSON.Classify.classify(json);
      if (typeof elementJsons === "object" && elementJsons.TAG === "Array") {
        let results = elementJsons._0.map((elemJson, index) => mapError(elementCodec.decode(elemJson), __x => prependLocation(__x, {
          TAG: "Index",
          _0: index
        })));
        return Stdlib_Array.reduce(results, {
          TAG: "Ok",
          _0: []
        }, (maybeAcc, res) => Stdlib_Result.flatMap(maybeAcc, acc => Stdlib_Result.map(res, x => Belt_Array.concatMany([
          acc,
          [x]
        ]))));
      }
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonType",
          VAL: [
            [],
            "array",
            json
          ]
        }
      };
    }
  };
}

function asObject(json) {
  let fieldset = Stdlib_JSON.Classify.classify(json);
  if (typeof fieldset === "object" && fieldset.TAG === "Object") {
    return {
      TAG: "Ok",
      _0: fieldset._0
    };
  }
  return {
    TAG: "Error",
    _0: {
      NAME: "UnexpectedJsonType",
      VAL: [
        [],
        "object",
        json
      ]
    }
  };
}

function makeOptional(param) {
  return {
    path: param.path,
    codec: nullable(param.codec),
    claim: "Optional"
  };
}

function path(param) {
  return param.path;
}

function codec(param) {
  return param.codec;
}

function claim(param) {
  return param.claim;
}

function encode(field, val) {
  let key = path(field);
  let json = codec(field).encode(val);
  if (json === null && claim(field) === "Optional") {
    return [];
  } else {
    return [[
        key._0,
        json
      ]];
  }
}

function decode(field, fieldset) {
  let key = path(field);
  let key$1 = key._0;
  let decodeChild = childJson => mapError(codec(field).decode(childJson), __x => prependLocation(__x, {
    TAG: "Field",
    _0: key$1
  }));
  let match = fieldset[key$1];
  let match$1 = claim(field);
  if (match !== undefined) {
    return decodeChild(match);
  } else if (match$1 === "Required") {
    return {
      TAG: "Error",
      _0: {
        NAME: "MissingField",
        VAL: [
          [],
          key$1
        ]
      }
    };
  } else {
    return decodeChild(null);
  }
}

function field(key, codec) {
  return {
    path: {
      TAG: "Key",
      _0: key
    },
    codec: codec,
    claim: "Required"
  };
}

function jsonObject(keyVals) {
  return Json.encodeDict(Object.fromEntries(Stdlib_Array.reduce(keyVals, [], (acc, arr) => Belt_Array.concatMany([
    acc,
    arr
  ]))));
}

function object1(destruct, construct, field1) {
  return {
    encode: value => {
      let val1 = destruct(value);
      return jsonObject([encode(field1, val1)]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG === "Ok") {
        return construct(val1._0);
      } else {
        return val1;
      }
    })
  };
}

function object2(destruct, construct, field1, field2) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0
        ]);
      } else {
        return val2;
      }
    })
  };
}

function object3(destruct, construct, field1, field2, field3) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0
        ]);
      } else {
        return val3;
      }
    })
  };
}

function object4(destruct, construct, field1, field2, field3, field4) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0
        ]);
      } else {
        return val4;
      }
    })
  };
}

function object5(destruct, construct, field1, field2, field3, field4, field5) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0
        ]);
      } else {
        return val5;
      }
    })
  };
}

function object6(destruct, construct, field1, field2, field3, field4, field5, field6) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0
        ]);
      } else {
        return val6;
      }
    })
  };
}

function object7(destruct, construct, field1, field2, field3, field4, field5, field6, field7) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0
        ]);
      } else {
        return val7;
      }
    })
  };
}

function object8(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0
        ]);
      } else {
        return val8;
      }
    })
  };
}

function object9(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0
        ]);
      } else {
        return val9;
      }
    })
  };
}

function object10(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0
        ]);
      } else {
        return val10;
      }
    })
  };
}

function object11(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0
        ]);
      } else {
        return val11;
      }
    })
  };
}

function object12(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0
        ]);
      } else {
        return val12;
      }
    })
  };
}

function object13(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0
        ]);
      } else {
        return val13;
      }
    })
  };
}

function object14(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12]),
        encode(field14, match[13])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG !== "Ok") {
        return val13;
      }
      let val14 = decode(field14, fieldset);
      if (val14.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0,
          val14._0
        ]);
      } else {
        return val14;
      }
    })
  };
}

function object15(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12]),
        encode(field14, match[13]),
        encode(field15, match[14])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG !== "Ok") {
        return val13;
      }
      let val14 = decode(field14, fieldset);
      if (val14.TAG !== "Ok") {
        return val14;
      }
      let val15 = decode(field15, fieldset);
      if (val15.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0,
          val14._0,
          val15._0
        ]);
      } else {
        return val15;
      }
    })
  };
}

function object16(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12]),
        encode(field14, match[13]),
        encode(field15, match[14]),
        encode(field16, match[15])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG !== "Ok") {
        return val13;
      }
      let val14 = decode(field14, fieldset);
      if (val14.TAG !== "Ok") {
        return val14;
      }
      let val15 = decode(field15, fieldset);
      if (val15.TAG !== "Ok") {
        return val15;
      }
      let val16 = decode(field16, fieldset);
      if (val16.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0,
          val14._0,
          val15._0,
          val16._0
        ]);
      } else {
        return val16;
      }
    })
  };
}

function object17(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12]),
        encode(field14, match[13]),
        encode(field15, match[14]),
        encode(field16, match[15]),
        encode(field17, match[16])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG !== "Ok") {
        return val13;
      }
      let val14 = decode(field14, fieldset);
      if (val14.TAG !== "Ok") {
        return val14;
      }
      let val15 = decode(field15, fieldset);
      if (val15.TAG !== "Ok") {
        return val15;
      }
      let val16 = decode(field16, fieldset);
      if (val16.TAG !== "Ok") {
        return val16;
      }
      let val17 = decode(field17, fieldset);
      if (val17.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0,
          val14._0,
          val15._0,
          val16._0,
          val17._0
        ]);
      } else {
        return val17;
      }
    })
  };
}

function object18(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12]),
        encode(field14, match[13]),
        encode(field15, match[14]),
        encode(field16, match[15]),
        encode(field17, match[16]),
        encode(field18, match[17])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG !== "Ok") {
        return val13;
      }
      let val14 = decode(field14, fieldset);
      if (val14.TAG !== "Ok") {
        return val14;
      }
      let val15 = decode(field15, fieldset);
      if (val15.TAG !== "Ok") {
        return val15;
      }
      let val16 = decode(field16, fieldset);
      if (val16.TAG !== "Ok") {
        return val16;
      }
      let val17 = decode(field17, fieldset);
      if (val17.TAG !== "Ok") {
        return val17;
      }
      let val18 = decode(field18, fieldset);
      if (val18.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0,
          val14._0,
          val15._0,
          val16._0,
          val17._0,
          val18._0
        ]);
      } else {
        return val18;
      }
    })
  };
}

function object19(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12]),
        encode(field14, match[13]),
        encode(field15, match[14]),
        encode(field16, match[15]),
        encode(field17, match[16]),
        encode(field18, match[17]),
        encode(field19, match[18])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG !== "Ok") {
        return val13;
      }
      let val14 = decode(field14, fieldset);
      if (val14.TAG !== "Ok") {
        return val14;
      }
      let val15 = decode(field15, fieldset);
      if (val15.TAG !== "Ok") {
        return val15;
      }
      let val16 = decode(field16, fieldset);
      if (val16.TAG !== "Ok") {
        return val16;
      }
      let val17 = decode(field17, fieldset);
      if (val17.TAG !== "Ok") {
        return val17;
      }
      let val18 = decode(field18, fieldset);
      if (val18.TAG !== "Ok") {
        return val18;
      }
      let val19 = decode(field19, fieldset);
      if (val19.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0,
          val14._0,
          val15._0,
          val16._0,
          val17._0,
          val18._0,
          val19._0
        ]);
      } else {
        return val19;
      }
    })
  };
}

function object20(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19, field20) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12]),
        encode(field14, match[13]),
        encode(field15, match[14]),
        encode(field16, match[15]),
        encode(field17, match[16]),
        encode(field18, match[17]),
        encode(field19, match[18]),
        encode(field20, match[19])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG !== "Ok") {
        return val13;
      }
      let val14 = decode(field14, fieldset);
      if (val14.TAG !== "Ok") {
        return val14;
      }
      let val15 = decode(field15, fieldset);
      if (val15.TAG !== "Ok") {
        return val15;
      }
      let val16 = decode(field16, fieldset);
      if (val16.TAG !== "Ok") {
        return val16;
      }
      let val17 = decode(field17, fieldset);
      if (val17.TAG !== "Ok") {
        return val17;
      }
      let val18 = decode(field18, fieldset);
      if (val18.TAG !== "Ok") {
        return val18;
      }
      let val19 = decode(field19, fieldset);
      if (val19.TAG !== "Ok") {
        return val19;
      }
      let val20 = decode(field20, fieldset);
      if (val20.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0,
          val14._0,
          val15._0,
          val16._0,
          val17._0,
          val18._0,
          val19._0,
          val20._0
        ]);
      } else {
        return val20;
      }
    })
  };
}

function object21(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19, field20, field21) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12]),
        encode(field14, match[13]),
        encode(field15, match[14]),
        encode(field16, match[15]),
        encode(field17, match[16]),
        encode(field18, match[17]),
        encode(field19, match[18]),
        encode(field20, match[19]),
        encode(field21, match[20])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG !== "Ok") {
        return val13;
      }
      let val14 = decode(field14, fieldset);
      if (val14.TAG !== "Ok") {
        return val14;
      }
      let val15 = decode(field15, fieldset);
      if (val15.TAG !== "Ok") {
        return val15;
      }
      let val16 = decode(field16, fieldset);
      if (val16.TAG !== "Ok") {
        return val16;
      }
      let val17 = decode(field17, fieldset);
      if (val17.TAG !== "Ok") {
        return val17;
      }
      let val18 = decode(field18, fieldset);
      if (val18.TAG !== "Ok") {
        return val18;
      }
      let val19 = decode(field19, fieldset);
      if (val19.TAG !== "Ok") {
        return val19;
      }
      let val20 = decode(field20, fieldset);
      if (val20.TAG !== "Ok") {
        return val20;
      }
      let val21 = decode(field21, fieldset);
      if (val21.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0,
          val14._0,
          val15._0,
          val16._0,
          val17._0,
          val18._0,
          val19._0,
          val20._0,
          val21._0
        ]);
      } else {
        return val21;
      }
    })
  };
}

function object22(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19, field20, field21, field22) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12]),
        encode(field14, match[13]),
        encode(field15, match[14]),
        encode(field16, match[15]),
        encode(field17, match[16]),
        encode(field18, match[17]),
        encode(field19, match[18]),
        encode(field20, match[19]),
        encode(field21, match[20]),
        encode(field22, match[21])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG !== "Ok") {
        return val13;
      }
      let val14 = decode(field14, fieldset);
      if (val14.TAG !== "Ok") {
        return val14;
      }
      let val15 = decode(field15, fieldset);
      if (val15.TAG !== "Ok") {
        return val15;
      }
      let val16 = decode(field16, fieldset);
      if (val16.TAG !== "Ok") {
        return val16;
      }
      let val17 = decode(field17, fieldset);
      if (val17.TAG !== "Ok") {
        return val17;
      }
      let val18 = decode(field18, fieldset);
      if (val18.TAG !== "Ok") {
        return val18;
      }
      let val19 = decode(field19, fieldset);
      if (val19.TAG !== "Ok") {
        return val19;
      }
      let val20 = decode(field20, fieldset);
      if (val20.TAG !== "Ok") {
        return val20;
      }
      let val21 = decode(field21, fieldset);
      if (val21.TAG !== "Ok") {
        return val21;
      }
      let val22 = decode(field22, fieldset);
      if (val22.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0,
          val14._0,
          val15._0,
          val16._0,
          val17._0,
          val18._0,
          val19._0,
          val20._0,
          val21._0,
          val22._0
        ]);
      } else {
        return val22;
      }
    })
  };
}

function object23(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19, field20, field21, field22, field23) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12]),
        encode(field14, match[13]),
        encode(field15, match[14]),
        encode(field16, match[15]),
        encode(field17, match[16]),
        encode(field18, match[17]),
        encode(field19, match[18]),
        encode(field20, match[19]),
        encode(field21, match[20]),
        encode(field22, match[21]),
        encode(field23, match[22])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG !== "Ok") {
        return val13;
      }
      let val14 = decode(field14, fieldset);
      if (val14.TAG !== "Ok") {
        return val14;
      }
      let val15 = decode(field15, fieldset);
      if (val15.TAG !== "Ok") {
        return val15;
      }
      let val16 = decode(field16, fieldset);
      if (val16.TAG !== "Ok") {
        return val16;
      }
      let val17 = decode(field17, fieldset);
      if (val17.TAG !== "Ok") {
        return val17;
      }
      let val18 = decode(field18, fieldset);
      if (val18.TAG !== "Ok") {
        return val18;
      }
      let val19 = decode(field19, fieldset);
      if (val19.TAG !== "Ok") {
        return val19;
      }
      let val20 = decode(field20, fieldset);
      if (val20.TAG !== "Ok") {
        return val20;
      }
      let val21 = decode(field21, fieldset);
      if (val21.TAG !== "Ok") {
        return val21;
      }
      let val22 = decode(field22, fieldset);
      if (val22.TAG !== "Ok") {
        return val22;
      }
      let val23 = decode(field23, fieldset);
      if (val23.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0,
          val14._0,
          val15._0,
          val16._0,
          val17._0,
          val18._0,
          val19._0,
          val20._0,
          val21._0,
          val22._0,
          val23._0
        ]);
      } else {
        return val23;
      }
    })
  };
}

function object24(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19, field20, field21, field22, field23, field24) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12]),
        encode(field14, match[13]),
        encode(field15, match[14]),
        encode(field16, match[15]),
        encode(field17, match[16]),
        encode(field18, match[17]),
        encode(field19, match[18]),
        encode(field20, match[19]),
        encode(field21, match[20]),
        encode(field22, match[21]),
        encode(field23, match[22]),
        encode(field24, match[23])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG !== "Ok") {
        return val13;
      }
      let val14 = decode(field14, fieldset);
      if (val14.TAG !== "Ok") {
        return val14;
      }
      let val15 = decode(field15, fieldset);
      if (val15.TAG !== "Ok") {
        return val15;
      }
      let val16 = decode(field16, fieldset);
      if (val16.TAG !== "Ok") {
        return val16;
      }
      let val17 = decode(field17, fieldset);
      if (val17.TAG !== "Ok") {
        return val17;
      }
      let val18 = decode(field18, fieldset);
      if (val18.TAG !== "Ok") {
        return val18;
      }
      let val19 = decode(field19, fieldset);
      if (val19.TAG !== "Ok") {
        return val19;
      }
      let val20 = decode(field20, fieldset);
      if (val20.TAG !== "Ok") {
        return val20;
      }
      let val21 = decode(field21, fieldset);
      if (val21.TAG !== "Ok") {
        return val21;
      }
      let val22 = decode(field22, fieldset);
      if (val22.TAG !== "Ok") {
        return val22;
      }
      let val23 = decode(field23, fieldset);
      if (val23.TAG !== "Ok") {
        return val23;
      }
      let val24 = decode(field24, fieldset);
      if (val24.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0,
          val14._0,
          val15._0,
          val16._0,
          val17._0,
          val18._0,
          val19._0,
          val20._0,
          val21._0,
          val22._0,
          val23._0,
          val24._0
        ]);
      } else {
        return val24;
      }
    })
  };
}

function object25(destruct, construct, field1, field2, field3, field4, field5, field6, field7, field8, field9, field10, field11, field12, field13, field14, field15, field16, field17, field18, field19, field20, field21, field22, field23, field24, field25) {
  return {
    encode: value => {
      let match = destruct(value);
      return jsonObject([
        encode(field1, match[0]),
        encode(field2, match[1]),
        encode(field3, match[2]),
        encode(field4, match[3]),
        encode(field5, match[4]),
        encode(field6, match[5]),
        encode(field7, match[6]),
        encode(field8, match[7]),
        encode(field9, match[8]),
        encode(field10, match[9]),
        encode(field11, match[10]),
        encode(field12, match[11]),
        encode(field13, match[12]),
        encode(field14, match[13]),
        encode(field15, match[14]),
        encode(field16, match[15]),
        encode(field17, match[16]),
        encode(field18, match[17]),
        encode(field19, match[18]),
        encode(field20, match[19]),
        encode(field21, match[20]),
        encode(field22, match[21]),
        encode(field23, match[22]),
        encode(field24, match[23]),
        encode(field25, match[24])
      ]);
    },
    decode: json => Stdlib_Result.flatMap(asObject(json), fieldset => {
      let val1 = decode(field1, fieldset);
      if (val1.TAG !== "Ok") {
        return val1;
      }
      let val2 = decode(field2, fieldset);
      if (val2.TAG !== "Ok") {
        return val2;
      }
      let val3 = decode(field3, fieldset);
      if (val3.TAG !== "Ok") {
        return val3;
      }
      let val4 = decode(field4, fieldset);
      if (val4.TAG !== "Ok") {
        return val4;
      }
      let val5 = decode(field5, fieldset);
      if (val5.TAG !== "Ok") {
        return val5;
      }
      let val6 = decode(field6, fieldset);
      if (val6.TAG !== "Ok") {
        return val6;
      }
      let val7 = decode(field7, fieldset);
      if (val7.TAG !== "Ok") {
        return val7;
      }
      let val8 = decode(field8, fieldset);
      if (val8.TAG !== "Ok") {
        return val8;
      }
      let val9 = decode(field9, fieldset);
      if (val9.TAG !== "Ok") {
        return val9;
      }
      let val10 = decode(field10, fieldset);
      if (val10.TAG !== "Ok") {
        return val10;
      }
      let val11 = decode(field11, fieldset);
      if (val11.TAG !== "Ok") {
        return val11;
      }
      let val12 = decode(field12, fieldset);
      if (val12.TAG !== "Ok") {
        return val12;
      }
      let val13 = decode(field13, fieldset);
      if (val13.TAG !== "Ok") {
        return val13;
      }
      let val14 = decode(field14, fieldset);
      if (val14.TAG !== "Ok") {
        return val14;
      }
      let val15 = decode(field15, fieldset);
      if (val15.TAG !== "Ok") {
        return val15;
      }
      let val16 = decode(field16, fieldset);
      if (val16.TAG !== "Ok") {
        return val16;
      }
      let val17 = decode(field17, fieldset);
      if (val17.TAG !== "Ok") {
        return val17;
      }
      let val18 = decode(field18, fieldset);
      if (val18.TAG !== "Ok") {
        return val18;
      }
      let val19 = decode(field19, fieldset);
      if (val19.TAG !== "Ok") {
        return val19;
      }
      let val20 = decode(field20, fieldset);
      if (val20.TAG !== "Ok") {
        return val20;
      }
      let val21 = decode(field21, fieldset);
      if (val21.TAG !== "Ok") {
        return val21;
      }
      let val22 = decode(field22, fieldset);
      if (val22.TAG !== "Ok") {
        return val22;
      }
      let val23 = decode(field23, fieldset);
      if (val23.TAG !== "Ok") {
        return val23;
      }
      let val24 = decode(field24, fieldset);
      if (val24.TAG !== "Ok") {
        return val24;
      }
      let val25 = decode(field25, fieldset);
      if (val25.TAG === "Ok") {
        return construct([
          val1._0,
          val2._0,
          val3._0,
          val4._0,
          val5._0,
          val6._0,
          val7._0,
          val8._0,
          val9._0,
          val10._0,
          val11._0,
          val12._0,
          val13._0,
          val14._0,
          val15._0,
          val16._0,
          val17._0,
          val18._0,
          val19._0,
          val20._0,
          val21._0,
          val22._0,
          val23._0,
          val24._0,
          val25._0
        ]);
      } else {
        return val25;
      }
    })
  };
}

let DecodingError = {};

let optional = makeOptional;

export {
  DecodingError,
  encodeWith,
  decodeWith,
  string,
  float,
  int,
  bool,
  array,
  field,
  optional,
  object1,
  object2,
  object3,
  object4,
  object5,
  object6,
  object7,
  object8,
  object9,
  object10,
  object11,
  object12,
  object13,
  object14,
  object15,
  object16,
  object17,
  object18,
  object19,
  object20,
  object21,
  object22,
  object23,
  object24,
  object25,
}
/* No side effect */
